export default __webpack_public_path__ + "static/business_2-302292acf8d371f6f01677bfc83943c9.jpg";